import Vue from 'vue'
import App from './App.vue'
import './custom.css' 
import VTree from 'vue-tree-halower'
import store from './store'


import Vuetify from 'vuetify'
import './vuetify.min_custom.css'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import VuePerfectScrollbar from "vue-perfect-scrollbar";

import router from './router'

Vue.config.productionTip = false
Vue.config.devtools = true;
console.log(router)


Vue.use(Vuetify);
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// import VueTouchRipple from 'vue-touch-ripple'
// import 'vue-touch-ripple/dist/vue-touch-ripple.css'
// Vue.use(VueTouchRipple)
var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})


Vue.config.productionTip = false
Vue.use(VTree)
import EventHub from './components/EventHub.js'
Vue.use(EventHub)

new Vue({
  router, // ルーティングのために追加
  render: h => h(App),
  vuetify : new Vuetify(),
  store, //storeをローカルに登録//これでどこからでも使える
  PerfectScrollbar,
  VuePerfectScrollbar,
}).$mount('#app')

